import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12154_2385)">
      <g clipPath="url(#clip1_12154_2385)">
        <path
          d="M10.9968 12.9969C10.7308 12.9969 10.4756 12.8912 10.2875 12.7031C10.0994 12.515 9.9937 12.2598 9.9937 11.9938V8.99379C9.98019 8.85454 9.99596 8.71401 10.04 8.58122C10.084 8.44843 10.1553 8.32631 10.2494 8.22272C10.3434 8.11913 10.458 8.03635 10.586 7.97971C10.7139 7.92306 10.8522 7.8938 10.9921 7.8938C11.132 7.8938 11.2704 7.92306 11.3983 7.97971C11.5262 8.03635 11.6409 8.11913 11.7349 8.22272C11.8289 8.32631 11.9003 8.44843 11.9443 8.58122C11.9883 8.71401 12.0041 8.85454 11.9906 8.99379V11.9938C11.9906 12.2582 11.8862 12.512 11.7001 12.6998C11.514 12.8877 11.2612 12.9944 10.9968 12.9969Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          d="M15 12.9969C14.7339 12.9969 14.4788 12.8912 14.2906 12.7031C14.1025 12.515 13.9968 12.2598 13.9968 11.9938V8.00001C14.0209 7.7519 14.1365 7.52164 14.3211 7.3541C14.5056 7.18656 14.746 7.09375 14.9953 7.09375C15.2445 7.09375 15.4849 7.18656 15.6695 7.3541C15.854 7.52164 15.9696 7.7519 15.9937 8.00001V12.0031C15.9913 12.2659 15.8858 12.5173 15.6999 12.7031C15.5141 12.889 15.2628 12.9944 15 12.9969Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          d="M19.0032 12.9971C18.7371 12.9971 18.482 12.8914 18.2939 12.7032C18.1057 12.5151 18 12.26 18 11.9939V6.00331C17.9865 5.86406 18.0023 5.72353 18.0463 5.59074C18.0904 5.45795 18.1617 5.33583 18.2557 5.23224C18.3497 5.12865 18.4644 5.04588 18.5923 4.98923C18.7202 4.93258 18.8586 4.90332 18.9985 4.90332C19.1384 4.90332 19.2767 4.93258 19.4047 4.98923C19.5326 5.04588 19.6472 5.12865 19.7413 5.23224C19.8353 5.33583 19.9066 5.45795 19.9506 5.59074C19.9947 5.72353 20.0104 5.86406 19.9969 6.00331V12.0033C19.9945 12.2661 19.889 12.5175 19.7032 12.7033C19.5173 12.8891 19.266 12.9946 19.0032 12.9971Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          d="M22.9969 30H7.00313C5.94144 30 4.92323 29.5782 4.17249 28.8275C3.42176 28.0768 3.00001 27.0586 3.00001 25.9969V7.875C2.99887 7.14136 3.1596 6.4165 3.47073 5.7521C3.78186 5.0877 4.23574 4.50012 4.80001 4.03125L8.25001 1.1625C9.14768 0.414436 10.2784 0.00327453 11.4469 0L22.9969 0C24.0586 0 25.0768 0.421757 25.8275 1.17249C26.5782 1.92322 27 2.94143 27 4.00313V25.9969C27 27.0586 26.5782 28.0768 25.8275 28.8275C25.0768 29.5782 24.0586 30 22.9969 30ZM11.4469 1.99688C10.7611 2.0077 10.0996 2.25246 9.57188 2.69062L6.07501 5.56875C5.73669 5.85017 5.46465 6.20278 5.27829 6.60143C5.09193 7.00008 4.99584 7.43494 4.99688 7.875V25.9969C4.99935 26.5257 5.21052 27.0322 5.58448 27.4062C5.95843 27.7801 6.46491 27.9913 6.99376 27.9938H22.9969C23.5257 27.9913 24.0322 27.7801 24.4062 27.4062C24.7801 27.0322 24.9913 26.5257 24.9938 25.9969V4.00313C24.9913 3.47428 24.7801 2.9678 24.4062 2.59385C24.0322 2.21989 23.5257 2.00872 22.9969 2.00625L11.4469 1.99688Z"
          fill="var(--tlx-cta-primary-default)"
          stroke="var(--tlx-stroke-border-default)"
          strokeWidth="0.8"
        />
      </g>
      <g clipPath="url(#clip2_12154_2385)">
        <path
          d="M14.75 20.1221C16.2688 20.1221 17.5 18.8909 17.5 17.3721C17.5 15.8533 16.2688 14.6221 14.75 14.6221C13.2312 14.6221 12 15.8533 12 17.3721C12 18.8909 13.2312 20.1221 14.75 20.1221Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.75 20.969C16.767 20.969 15.969 21.767 15.969 22.75C15.969 23.733 16.767 24.5315 17.75 24.5315C18.733 24.5315 19.5315 23.733 19.5315 22.75C19.5315 21.767 18.733 20.969 17.75 20.969ZM17.75 21.719C18.319 21.719 18.7815 22.181 18.7815 22.75C18.7815 23.319 18.319 23.7815 17.75 23.7815C17.181 23.7815 16.7185 23.319 16.7185 22.75C16.7185 22.181 17.181 21.719 17.75 21.719Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.125 21.3435V20.5C18.125 20.293 17.957 20.125 17.75 20.125C17.543 20.125 17.375 20.293 17.375 20.5V21.344C17.375 21.5505 17.543 21.719 17.75 21.719C17.957 21.7185 18.125 21.5505 18.125 21.3435Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0094 22.0211L19.6059 21.4241C19.7524 21.2781 19.7524 21.0401 19.6059 20.8941C19.4599 20.7476 19.2219 20.7476 19.0759 20.8941L18.4789 21.4906C18.3329 21.6371 18.3329 21.8746 18.4789 22.0211C18.6254 22.1671 18.8629 22.1671 19.0094 22.0211Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.156 23.125H20C20.207 23.125 20.375 22.957 20.375 22.75C20.375 22.543 20.207 22.375 20 22.375H19.156C18.9495 22.375 18.7815 22.543 18.7815 22.75C18.781 22.957 18.9495 23.125 19.156 23.125Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4789 24.0096L19.0759 24.6061C19.2219 24.7526 19.4599 24.7526 19.6059 24.6061C19.7524 24.4601 19.7524 24.2221 19.6059 24.0761L19.0094 23.4791C18.8629 23.3331 18.6254 23.3331 18.4789 23.4791C18.3329 23.6256 18.3329 23.8631 18.4789 24.0096Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.375 24.156V25C17.375 25.207 17.543 25.375 17.75 25.375C17.957 25.375 18.125 25.207 18.125 25V24.156C18.125 23.9495 17.957 23.7815 17.75 23.781C17.543 23.781 17.375 23.9495 17.375 24.156Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4906 23.4791L15.8941 24.0761C15.7476 24.2221 15.7476 24.4601 15.8941 24.6061C16.0401 24.7526 16.2781 24.7526 16.4241 24.6061L17.0211 24.0096C17.1671 23.8631 17.1671 23.6256 17.0211 23.4791C16.8746 23.3331 16.6371 23.3331 16.4906 23.4791Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3435 22.375H15.5C15.293 22.375 15.125 22.543 15.125 22.75C15.125 22.957 15.293 23.125 15.5 23.125H16.3435C16.5505 23.125 16.719 22.957 16.7185 22.75C16.7185 22.543 16.5505 22.375 16.3435 22.375Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0211 21.4906L16.4241 20.8941C16.2781 20.7476 16.0401 20.7476 15.8941 20.8941C15.7476 21.0401 15.7476 21.2781 15.8941 21.4241L16.4906 22.0211C16.6371 22.1671 16.8746 22.1671 17.0211 22.0211C17.1671 21.8746 17.1671 21.6371 17.0211 21.4906Z"
          fill="var(--tlx-cta-primary-default)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.468 24.878C15.201 24.535 15.225 24.0375 15.5405 23.7225L15.6375 23.625H15.5C15.017 23.625 14.625 23.233 14.625 22.75C14.625 22.267 15.017 21.875 15.5 21.875H15.6375L15.5405 21.7775C15.2125 21.45 15.1995 20.9255 15.5015 20.582C15.2565 20.563 15.0055 20.553 14.75 20.553C13.089 20.553 11.6185 20.9685 10.7055 21.591C10.009 22.066 9.625 22.6695 9.625 23.303V24.028C9.625 24.2535 9.7145 24.47 9.874 24.629C10.0335 24.7885 10.2495 24.878 10.475 24.878H15.468Z"
          fill="var(--tlx-cta-primary-default)"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12154_2385">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_12154_2385">
        <rect width="30" height="30" fill="white" />
      </clipPath>
      <clipPath id="clip2_12154_2385">
        {/* Literal white, like its clip0/clip1 siblings: a clipPath uses only
            this rect's geometry, so a themed fill here is inert and misleads
            the next reader into thinking it paints something. */}
        <rect width="12" height="12" fill="white" transform="translate(9 14)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
